import React, { PropTypes } from "react";
import Invoice from '../../assets/images/Invoice.png'


export default class InvoicePdfContent extends React.Component {
    constructor(props) {
        super(props);
        this.goBack = this.goBack.bind(this);
    }

    //  eslint-disable-next-line react/no-deprecated

    goBack = () => {
        // console.log(this.props);
        this.props.history.goBack();
    };

    _renderLeftpart2 = () => {
        const { totalRewal } = this.props.invoice;
        var rewal = (totalRewal.toString()).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
        return (
            <table className="table pdf-table">
                <thead>
                    <tr>
                        <th>ご請求金額</th>
                        <th>¥{rewal}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td className="pdf-table-td1">
                            件名　：
                    </td>
                        <td>
                            taskellご利用料
                    </td>
                    </tr>
                    <tr>
                        <td className="pdf-table-td1">
                            支払条件　：
                    </td>
                        <td>
                            口座振込
                    </td>
                    </tr>
                    <tr>
                        <td className="pdf-table-td1">
                            お支払期限　：
                    </td>
                        <td>
                            {this.props.dueDate}
                        </td>
                    </tr>
                </tbody>
            </table>
        )
    }

    _renderPaymentItems = () => {
        const items = this.props.invoice.Items;

        if (items !== null && items.constructor === Array && items.length > 0) {
            const sortedItems = items.sort((a, b) => b.startDate - a.startDate)
            return sortedItems.map(item => {

                return (
                    <tr>
                        <td className="td-Id">
                            {item.taskId}
                        </td>
                        <td className="td-Title">
                            {item.title}
                        </td>
                        <td className="td-Date">
                            {item.startDate + " " + item.workTime}
                        </td>
                        <td className="td-amount">
                            ￥{String(item.amount).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')}
                        </td>
                        <td className="td-worker">1</td>
                        <td className="td-subtotal">￥{String(item.amount).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')}</td>
                    </tr>
                );
            });
        }
        return (
            <tr>
                <td colSpan="6">請求対象となる実施済みのタスクがありません。</td>
            </tr>
        );
    };

    _renderPart4 = () => {
        return (
            <table className="table pdf-invoice-table">
                <thead>
                    <tr>
                        <th >タスクID</th>
                        <th>施日時</th>
                        <th />
                        <th />
                        <th>報酬金額{this.props.total}</th>
                    </tr>
                <tr>
                    <th >Taskell タスクID</th>
                    <th >タスク名</th>
                    <th>実地日</th>
                    <th/>
                    <th/>
                    <th>小計{this.props.total}</th>
                </tr>
                </thead>
                <tbody>
                    {this._renderPaymentItems()}
                </tbody>
            </table>
        )
    }

    render = () => {
        const { totalRewal } = this.props.invoice;
        var rewal = (totalRewal.toString()).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
        var today = new Date();
        var year = today.getFullYear();
        var month = today.getMonth() + 1;
        var day = today.getDay();
        return (
            <div className="invoice_layout">
                <div className="invoice">
                    <div className="row">
                        <div className="part0" style={{ backgroundImage: 'url(' + Invoice + ')' }} />
                        <div className="issue-billing">
                            <div className="issue-billing-inner">
                                <div className="issue-billing-common">
                                    <div className="part0_3">発行日</div>
                                    <div className="part0_3_1">{year}年{month}月{day}日</div>
                                </div>
                                <div className="issue-billing-common">
                                    <div className="part0_3">請求ID  </div>
                                    <div className="part0_3_1">{this.props.invoiceId}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="part1">
                        <div className="invoice_title">
                            {this.props.enterpriseName} 御中
                        </div>
                    </div>
                    <div className="row">
                        <div className="amount-address">
                            <div className="amount-address-left">
                                {this._renderLeftpart2()}
                            </div>
                            <div className="amount-address-right">
                                <div>株式会社シオン</div>
                                <div>〒105-0014</div>
                                <div>東京都港区芝2-3-9</div>
                                <div>VORT芝公園Ⅱ 2階</div>
                            </div>
                        </div>
                        <div className="part3">下記の通りご請求申し上げます。</div>
                        <div className="part4">
                            {this._renderPart4()}
                        </div>
                        <div className="part5">
                            {/* <div className="part5_2">中計 {this.props.total}</div> */}
                            <div className="part5_1" />
                            <table className="table pdf-invoice-table">
                                <tbody>
                                    <tr>
                                        <td className="td-Id" />
                                        <td className="td-Date" />
                                        <td className="td-amount" />
                                        <td className="td-worker">
                                            ご利用手数料 {this.props.feeRate}%
                                        </td>
                                        <td className="td-subtotal">{this.props.feeRateAmnt}</td>
                                    </tr>
                                    <tr>
                                        <td className="td-Id" />
                                        <td className="td-Date" />
                                        <td className="td-amount" />
                                        <td className="td-worker">
                                            消費税 {this.props.consumptionTax}%
                                        </td>
                                        <td className="td-subtotal">{this.props.consumptionTaxAmnt}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="part5 tax-consumption">
                            <table className="table pdf-invoice-table">
                                <tbody>
                                    <tr>
                                        <td className="td-Id" />
                                        <td className="td-Date" />
                                        <td className="td-amount" />
                                        <td className="td-worker">
                                            合計 (消費税込み)
                                            </td>
                                        <td className="td-subtotal">¥{rewal}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="part7">
                            <div className="part7_1 row">
                                <div className="part7_2">お振込先</div></div>
                            <div className="part7_1 row">
                                <div className="part7_2">金融機関名 ：</div>
                                <div className="part7_3">三井住友銀行</div>
                            </div>
                            <div className="part7_1 row">
                                <div className="part7_2">支店名 ：</div>
                                <div className="part7_3">神田支店 (219)</div>
                            </div>
                            <div className="part7_1 row">
                                <div className="part7_2">口座種別 ：</div>
                                <div className="part7_3">普通</div>
                            </div>
                            <div className="part7_1 row">
                                <div className="part7_2">口座番号 ：</div>
                                <div className="part7_3">3380198</div>
                            </div>
                            <div className="part7_1 row">
                                <div className="part7_2">口座名義 ：</div>
                                <div className="part7_3">カ) シオン</div>
                            </div>
                            <div className="part7_1 row">*恐れ入りまずが振り込み手数料は貴社にてご負担ください。</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };
};

